import type { CSSObject } from "type/tss";
import { Theme } from "@mui/material/styles";

export const styles = (theme: Theme) => {
	return ({
		errorMessage: {
			color: theme.palette.error.main,
			fontWeight: "bold",
		},
		sectionHeader: {
			fontWeight: 'bold',
		},
		sectionHeaderWithMargin: {
			fontWeight: 'bold',
		},
		divider: {
			marginTop: '24px',
			marginBottom: '24px'
		},
		saveButton: {
			marginRight: 8
		},
		toggleFieldsContainer: {
			display: 'flex',
			flexDirection: 'column',
			gap: '16px'
		}
	} satisfies Record<string, CSSObject>)
}
